/**
 * @generated SignedSource<<9a1d79f2c03352bba54140663fc3347a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedAboutItemPanel_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetails_item" | "PdpSharedDescriptionAbout_item">;
  readonly " $fragmentType": "PdpRespSharedAboutItemPanel_item";
};
export type PdpRespSharedAboutItemPanel_item$key = {
  readonly " $data"?: PdpRespSharedAboutItemPanel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedAboutItemPanel_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedAboutItemPanel_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAbout_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetails_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "3d80a2eeb417f0773dba00a0566c822f";

export default node;
